import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";

import { JobsService } from "../../jobs-and-tasks/jobs.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import {
  ClientInformationData,
  DeleteNoteSubject,
  Note,
  UpdateNoteSubject,
} from "../note-models";
import { Subject } from "rxjs";
import { NotesService } from "../notes.service";
import { PinnedService } from "../../pinned-panel/pinned.service";
import { HotToastService } from "@ngneat/hot-toast";
import {
  PinnedModels,
  PinnedModelsApps,
} from "../../pinned-panel/pinned-models";
import { CommonModule, NgIf } from "@angular/common";
import { Editor, EditorModule } from "primeng/editor";
import { FormsModule } from "@angular/forms";
import { PinComponent } from "src/app/design-system/components/pin/pin.component";

@Component({
    selector: "app-edit-note-card-modal",
    templateUrl: "./edit-note-card-modal.component.html",
    styleUrls: ["./edit-note-card-modal.component.scss"],
    imports: [CommonModule, FormsModule, NgIf, EditorModule, PinComponent]
})
export class EditNoteCardModalComponent implements OnInit, AfterViewInit {
  public onClose: Subject<UpdateNoteSubject | boolean>;

  @Input() note: Note;
  @Input() clientInformation: ClientInformationData;
  @Input() isClientInformation: boolean = false;
  @Input() isPinned: boolean = false;

  @ViewChild("rte") public rte: Editor;

  inputTitle: string;
  pinTypeNote = PinnedModels.Note;

  constructor(
    public jobsService: JobsService,
    private cdr: ChangeDetectorRef,
    public bsModalRef: BsModalRef,
    private notesService: NotesService,
    private pinnedService: PinnedService,
    private toastr: HotToastService
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();
    this.inputTitle = this.note?.title ?? null;
  }

  ngAfterViewInit(): void {}

  confirm(): void {
    // edge case for the first client information note
    if (this.isClientInformation) {
      this.onClose.next({
        clientInformationContent: this.clientInformation.content,
      });
      this.bsModalRef.hide();
      return;
    }

    const newTitle = this.inputTitle;
    const newContent: string = this.isClientInformation
      ? this.clientInformation.content
      : this.note.content;

    if (this.note) {
      this.note.title = newTitle;
      this.note.content = newContent;
      this.onClose.next({ note: this.note });
    } else if (this.clientInformation.content) {
      if (newContent !== this.clientInformation.content) {
        this.onClose.next({ clientInformationContent: newContent });
      }
    }
    this.bsModalRef.hide();
  }

  cancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }

  deleteNote(title: string, uuid: string) {
    this.notesService.deleteNoteSubject.next({ title, uuid });
    this.notesService.hideEditModalSubject.subscribe((res: boolean) => {
      if (res) {
        this.bsModalRef.hide();
      }
    });
  }

  async pinOrUnpinNote(): Promise<void> {
    if (!this.isPinned) {
      const { uuid: companyUuid } = await this.notesService.getCompanyUuid(
        this.note.company
      );

      const data = {
        model_name: PinnedModels.Note,
        model_app_name: PinnedModelsApps.Note,
        object_pk: this.note.uuid,
      };

      const { pinned_item, message } = await this.pinnedService.pinItem(
        data,
        companyUuid
      );

      this.cdr.detectChanges();

      // For UI update purposes, when pinning a note or a job (same screen)
      this.pinnedService.sendNewPinnedItemToComponent.next({ pinned_item });
      this.toastr.success(message);
      return;
    }

    this.pinnedService.unpinItemSubject.next(this.note.uuid);
    this.bsModalRef.hide();
  }
}
